import React, { Component } from 'react';
import { Card, CardHeader, Button, CardBody } from 'reactstrap';
import { connect } from 'react-redux'

import SelectButtonGroup from './components/SelectButtonGroup';
import SnoozeCard from './components/SnoozeCard';
import HourStepCounter from './components/HourStepCounter';
import HeaderComponent from '../../../components/header/HeaderComponent';
import { addJobForSnooze, updateSnoozeState } from "../utils/commonSnoozeUtils";

const arraySort = require('array-sort');
const constants = require('../../../utils/domain/constants');
const viewUtil = require('../../../utils/view/viewUtil');
const typeUtil = require('../../../utils/type/typeUtil');
const dateUtil = require('../../../utils/dateUtil/dateUtil');
const stringUtil = require('../../../utils/string/stringUtil');
const propertySnoozeUtils = require('./utils/propertySnoozeUtils');
const localizationUtils = require('../../../utils/domain/localizationUtils');
const translator = require('../../../utils/translator/translator');
const stateManager = require("../../../utils/state/stateManager");
const navigationPageAction = require('../../../utils/state/actions/views/navigationPage/navigationPageAction');


class PropertySnoozeView extends Component
{
    constructor(props)
    {
        super(props);

        this.state = {};

        this.state.propertySnoozeDetails = typeUtil.deepCloneObject(this.getPropertySnoozeDetails(this.props.snoozes));
        this.state.propertySnoozeDetails = arraySort(this.state.propertySnoozeDetails, "expiry");

        this.state.selectedDispatchTypes = [];
        this.state.selectedVenueCodes = [];
        this.state.selectedChannels = [];
        this.state.selectedHours = 0;

        this.getPropertySnoozeDetails = this.getPropertySnoozeDetails.bind(this);
        this.onPublish = this.onPublish.bind(this);
        this.onBackButtonClick = this.onBackButtonClick.bind(this);
    }

    componentWillReceiveProps(nextProps) 
    {
        const propertySnoozeDetails = typeUtil.deepCloneObject(this.getPropertySnoozeDetails(nextProps.snoozes));
        this.setState({ propertySnoozeDetails });
    }

    getPropertySnoozeDetails(snoozes)
    {
        return snoozes.filter(snooze => stringUtil.areStringSame(snooze.type, constants.SnoozeTypes.property))
    }

    render()
    {
        return (
            <Card>
            
                <HeaderComponent title={translator.getLabel("propertySnooze")}>
                    <div className='d-flex'>
                        <div className='flex-grow-1 d-flex justify-content-end flex-row'>
                            <Button
                                className='btn-cancel'
                                onClick={() =>
                                {
                                    this.onBackButtonClick();
                                }}
                            >
                                {translator.getLabel("cancel")}
                            </Button>
                            &nbsp;&nbsp;
                            <Button
                                className='btn-ok'
                                onClick={() => this.onPublish()}
                            >
                                {translator.getLabel("Publish")}
                            </Button>
                        </div>
                    </div>
                </HeaderComponent>

                <CardBody>

                    <div className='d-flex justify-content-between'>

                        <div style={{ width: "65%", marginRight: "10px" }}>{this.renderAddSnoozeSection()}</div>
                        <div style={{ width: "35%" }} >{this.renderActiveSnoozeList()}</div>

                    </div>

                </CardBody>

            </Card>
        );
    }

    async onPublish()
    {
        try 
        {
            const existingSnoozes = this.getPropertySnoozeDetails(this.props.snoozes);
            let propertySnoozes = [];
            this.state.propertySnoozeDetails.forEach(propertySnoozeDetail =>
            {
                const existingSnooze = existingSnoozes.find(s => s.primaryId === propertySnoozeDetail.primaryId);
                if (existingSnooze)
                {
                    if (propertySnoozeDetail.expiry && dateUtil.isBefore(propertySnoozeDetail.expiry, dateUtil.getNow()))
                    {
                        propertySnoozeDetail.isSnoozed = false;
                        propertySnoozeDetail.expiry = null;
                    }

                    propertySnoozes.push(propertySnoozeDetail);
                }
                else if (propertySnoozeDetail.isSnoozed) 
                {
                    propertySnoozes.push(propertySnoozeDetail);
                }
            });


            viewUtil.showPrompt(
                translator.getLabel('snooze'),
                translator.getLabel('you_are_about_to_publish_property_snoozes'),
                translator.getLabel('are_you_sure_you_want_to_proceed'),
                () =>
                {
                    addJobForSnooze(propertySnoozes, constants.SnoozeTypes.property);
                    updateSnoozeState(propertySnoozes, constants.SnoozeTypes.property);
                    stateManager.getStore().dispatch(navigationPageAction.createAction(null));
                },
                () =>
                {
                    stateManager.getStore().dispatch(navigationPageAction.createAction(null));
                });
        }
        catch (error) 
        {
            viewUtil.showErrorAlert(error);
        }
    }

    onBackButtonClick()
    {
        stateManager.getStore().dispatch(navigationPageAction.createAction(null));
    }

    renderActiveSnoozeList()
    {
        return (
            <Card>
                <CardHeader>
                    {translator.getLabel("active_snooze_list")}
                </CardHeader>
                <CardBody>
                    {
                        this.state.propertySnoozeDetails.length === 0
                            ? <div className='py-5' style={{ textAlign: "center" }}>
                                {translator.getLabel("no_active_snooze_available")}
                            </div>

                            : this.state.propertySnoozeDetails.filter(tuple => dateUtil.isAfter(tuple.expiry, dateUtil.getNow())).map(tuple =>
                                <SnoozeCard
                                    data={tuple}
                                    onDelete={(data) =>
                                    {
                                        const propertySnoozeDetail = this.state.propertySnoozeDetails.find(snooze => snooze.primaryId === data.primaryId);
                                        propertySnoozeDetail.isSnoozed = false;
                                        this.setState({});
                                    }}
                                    onUndo={(data) =>
                                    {
                                        const propertySnoozeDetail = this.state.propertySnoozeDetails.find(snooze => snooze.primaryId === data.primaryId);
                                        propertySnoozeDetail.isSnoozed = true;
                                        this.setState({});
                                    }} />
                            )
                    }
                </CardBody>
            </Card>
        );
    }

    renderAddSnoozeSection()
    {
        return (
            <Card>

                <CardHeader>
                    {translator.getLabel("create_new_property_snooze")}
                </CardHeader>

                <CardBody className='d-flex flex-column'>

                    <div className='mb-2'>{this.renderDispatchTypesToolbar()}</div>
                    <div className='mt-2 mb-1'>{this.renderVenueTypesToolbar()}</div>
                    <div className='mt-2 mb-1'>{this.renderChannelsToolbar()}</div>
                    <div className='mt-2 mb-1'>{this.renderExpiryCounter()}</div>

                </CardBody>

            </Card>
        );
    }

    renderDispatchTypesToolbar()
    {
        return <SelectButtonGroup
            label={translator.getLabel("select_dispatch_types")}
            options={constants.getDispatchTypeImages()}
            valueList={this.state.selectedDispatchTypes}
            onSelect={(value) => 
            {
                const selectedDispatchTypes = this.state.selectedDispatchTypes;
                if (selectedDispatchTypes.includes(value))
                {
                    const index = selectedDispatchTypes.findIndex(option => option === value);
                    selectedDispatchTypes.splice(index, 1);
                }
                else
                {
                    selectedDispatchTypes.push(value);
                }
                this.setState({});
            }} />
    }

    renderVenueTypesToolbar()
    {
        const venues = localizationUtils.getApplicableVenues();
        const venueCodes = venues.map(venue => ({ value: venue.code, imageUrl: venue.logoImageUrl }));

        return <SelectButtonGroup
            label={translator.getLabel("select_venues")}
            options={venueCodes}
            valueList={this.state.selectedVenueCodes}
            onSelect={(value) => 
            {
                const selectedVenueCodes = this.state.selectedVenueCodes;
                if (selectedVenueCodes.includes(value))
                {
                    const index = selectedVenueCodes.findIndex(option => option === value);
                    selectedVenueCodes.splice(index, 1);
                }
                else
                {
                    selectedVenueCodes.push(value);
                }
                this.setState({});
            }} />
    }

    renderChannelsToolbar()
    {
        return <SelectButtonGroup
            label={translator.getLabel("select_channels")}
            options={constants.getChannelImages()}
            valueList={this.state.selectedChannels}
            onSelect={(value) => 
            {
                const selectedChannels = this.state.selectedChannels;
                if (selectedChannels.includes(value))
                {
                    const index = selectedChannels.findIndex(option => option === value);
                    selectedChannels.splice(index, 1);
                }
                else
                {
                    selectedChannels.push(value);
                }
                this.setState({});
            }} />
    }

    renderExpiryCounter()
    {
        let selectedHours = this.state.selectedHours

        return <HourStepCounter
            hours={selectedHours}
            label={translator.getLabel("select_snooze_duration")}
            onIncrement={() =>
            {
                selectedHours = ++selectedHours;
                if (selectedHours > 24) selectedHours = 24;
                this.setState({ selectedHours: selectedHours });
            }}
            onDecrement={() =>
            {
                selectedHours = --selectedHours;
                if (selectedHours < 0) selectedHours = 0;
                this.setState({ selectedHours: selectedHours });
            }}
            onSave={() => this.addPropertySnooze()} />
    }

    async addPropertySnooze()
    {
        const { selectedHours, selectedDispatchTypes, selectedVenueCodes, selectedChannels } = this.state;

        if (selectedHours == 0)
        {
            viewUtil.showErrorAlert(translator.getLabel("snooze_duration_is_not_selected"));
            return;
        }

        if (selectedDispatchTypes.length === 0 && selectedVenueCodes.length === 0 && selectedChannels.length === 0)
        {
            viewUtil.showErrorAlert(translator.getLabel("select_at_least_one_dispatch_type"));
            return;
        }

        let newSnoozeDetails = propertySnoozeUtils.getSnoozes(selectedDispatchTypes, selectedVenueCodes, selectedChannels, selectedHours);
        this.state.propertySnoozeDetails = this.state.propertySnoozeDetails.concat(newSnoozeDetails);
        this.state.propertySnoozeDetails = arraySort(this.state.propertySnoozeDetails, "expiry");

        this.state.selectedDispatchTypes = [];
        this.state.selectedVenueCodes = [];
        this.state.selectedChannels = [];
        this.state.selectedHours = 0;
        this.setState({})
    }
}

const mapStateToProps = state => 
{
    return {
        snoozes: state.snoozes
    }
}

export default connect(mapStateToProps)(PropertySnoozeView);